import {
   isAfter
  ,isBefore
  ,isWithinInterval
} from 'external/date-fns'
import {
  clsx,
  styled,
  Box,
} from 'external/material'

import LinkBehavior from 'components/LinkBehavior'
import useSession from 'hooks/session'
import useTranslations from 'hooks/translations'
import useAssessment from 'hooks/assessment'

const actions = [
  {type: 'continue', classes: {}, test: ({duration, finished, durationSinceStart}) => !finished && durationSinceStart > 0 && duration > durationSinceStart},
  {type: 'expired', classes: {disabled: true}, test: ({finished, duration, durationSinceStart}) => !finished && durationSinceStart >= duration},
  {type: 'finished', classes: {disabled: true}, test: ({started, finished}) => started != null && finished != null},
  {type: 'missed', classes: {disabled: true}, test: ({finish, started, finished}) => isAfter(new Date(), finish) && !started && !finished},
  {type: 'start', classes: {}, test: ({started, start, finish}) => !started && isWithinInterval(new Date(), {start, end: finish})},
  {type: 'scheduled', classes: {disabled: true}, test: ({started, start, finish}) => !started && isBefore(new Date(), start)}
]

const ActionContainer = styled(Box)(actionStyles)

export default function Action({assessment}) {

  const action = actions.find(({test}) => test(assessment))
  const {navigation} = useSession()
  const {translate} = useTranslations()
  const {start} = useAssessment()


  let actionProperties = {}

  async function handleStart () {
    const assessmentId = await start(assessment.id)
    navigation.assessment.go({assessmentId})
  }

  if (action.type == 'continue')
    actionProperties = {component: LinkBehavior, to: navigation.assessment.link({assessmentId: assessment.answeredAssessment})}
  else if (action.type == 'start')
    actionProperties = {onClick: handleStart}
  
  return (
    <ActionContainer className={clsx('action', action.type, action.classes)} {...actionProperties} >
      {translate(action.type)}
    </ActionContainer>
  )
}

function actionStyles() {
  return {
    "&.action": {
      padding: '4px 8px',
      color: '#2773bf',
      borderRadius: 20,
      border: 'solid 1px #2773bf',
      cursor: 'pointer',
      textDecoration: 'none',
      "&.disabled": {
        cursor: 'default',
        color: '#87929c',
        backgroundColor: '#e6e9ed',
        border: 'solid 1px #e6e9ed'
      }
    }
  }
}

